<template>
    <div class="compChoose">
        <ul>
            <li class="li-title">
                <img :src="require('@/assets/images/tusu.png')" width="24" alt="">
                请选择投诉原因：
            </li>
            <li v-for="item in queryList" :key="item.name" @click="handleClick(item)">
                <img :src="item.icon" width="26" alt="">
                <span>{{item.name}}</span>
            </li>
        </ul>

        <p>如需要帮助，请联系<i><van-icon name="service-o" @="callMe" />在线客服</i></p>
    </div>
</template>
<script>
export default {
    data() {
        return {
            routeObj: {},
            queryList: [
                {name: '充值未到账', icon: require('@/assets/images/daozhang.png')},
                {name: '充错账号', icon: require('@/assets/images/error_3.png')},
                {name: '遭遇诈骗', icon: require('@/assets/images/zhap.png')},
                {name: '其他原因', icon: require('@/assets/images/msg.png')},
            ],
        }
    },
    created() {
        this.routeObj = this.$route.query;
    },
    methods: {
        callMe() {
            
        },
        handleClick(item) {
            this.$router.push({
                path: '/compDetails',
                query: {
                    reason: item.name,
                    orderNo: this.routeObj?.orderNo,
                }
            });
        }
    }
}
</script>
<style lang="less" scoped>
    .compChoose {
        padding: 15px;
        color: #000;
        font-size: 16px;
        ul {
            background: #fff;
            border-radius: 6px;
            padding: 30px 15px;
            box-shadow: 0 0 8px #ebedf0;
            .li-title {
                justify-content: left;
            }
            li {
                background: #f8f8f8;
                height: 70px;
                border-radius: 8px;
                line-height: 70px;
                margin-bottom: 15px;
                display: flex;
                gap: 3px;
                align-items: center;
                justify-content: center;
                padding: 0 15px;
                font-size: 18px;
            }
            li:last-child {
                margin-bottom: 0;
            }
        }
        p {
            margin: 10px 0;
            text-align: center;
            i {
                color: #e0620d;
            }
        }
    }
</style>